import { bulkWorkflows } from './workflows';

const operationGroups: readonly (readonly string[])[] = [
  ['EMPLOYEE_HIRE', 'EMPLOYEE_IMPORT', 'EMPLOYEE_REHIRE'],
  ['STAFFING_CHANGE', 'WORKER_LIFECYCLE_CORRECTION'],
  ['TIME_OFF_CORRECTION', 'TIME_OFF_GRANT', 'TIME_OFF_ADJUSTMENT'],
];

export function contextualBulkWorkflows(operation: string, allowedOperationTypes: readonly string[]) {
  const group = operationGroups.find((items) => items.includes(operation)) ?? [operation];
  return bulkWorkflows.filter((workflow) => group.includes(workflow.operationType) && allowedOperationTypes.includes(workflow.operationType));
}

export function bulkOperationLabel(value: string) {
  return bulkWorkflows.find((workflow) => workflow.operationType === value)?.label ?? value;
}

export function bulkStatusLabel(value: string) {
  return ({ VALID: '검증 완료', INVALID: '입력 오류', SUCCEEDED: '요청 제출 완료', FAILED: '처리 실패', VALIDATED: '검증 완료', COMPLETED: '완료', COMPLETED_WITH_ERRORS: '일부 실패', PROCESSING: '처리 중', QUEUED: '적용 대기', DRAFT: '작성 중', CANCELLED: '취소됨' } as Record<string, string>)[value] ?? value;
}

export function isBulkJobActive(status: string) {
  return status === 'QUEUED' || status === 'PROCESSING';
}

export function bulkDateLabel(value: string) {
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '일시 확인 불가' : new Intl.DateTimeFormat('ko-KR', { month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit' }).format(date);
}
